import Vue from 'vue'
import Vuex from 'vuex'
import actions from './common/actions'
import getters from './common/getters'
import mutations from './common/mutations'
import state from './common/state'
// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'

Vue.use(Vuex)

export default new Vuex.Store({
    state,
    actions,
    getters,
    mutations,
    modules: {
        app,
        appConfig,
        verticalMenu
    },
    strict: process.env.DEV
})
